import { RootState } from 'reduxStore/store';

const getUsers = (state: RootState) => state.users.users;

export { getUsers };
